<template>
  <div>
    <div class="text-left pd-b-3 flex-display ai-center js-end pd-t-4">
      <a
        @click="
          checkedCourseTestCopy =[],checkedAll=false, dialogCourseTestCopy = true
        "
        class="color-primary-light mg-r-3"
      >
        <i class="fas fa-file-upload"></i>
        นำเข้าแบบทดสอบ
      </a>
      <a
        @click="
          [resetCourseTest(), setCourse(), (dialogCourseTestVisible = true)]
        "
        
        class="color-primary-light"
      >
        +
        {{
          testType == "preTest"
            ? "เพิ่มข้อสอบ Pre-Test"
            : "เพิ่มข้อสอบ Post-Test"
        }}
      </a> 
    </div>
    <div>
      <el-table
        v-if="showTable"
        :data="coureTestList"
        border
        :header-row-style="tableHeaderStyle"
        :header-cell-style="tableHeaderStyle"
        empty-text="ไม่พบข้อมูล"
      >
        <el-table-column
          type="index"
          label="ลำดับ"
          header-align="center"
          align="center"
          sortable
          width="80"
        ></el-table-column>
        <el-table-column
          prop="question"
          label="คำถาม"
          header-align="center"
          sortable
          :width="widthMax < 767.98 ? '160' : ''"
        >
          <template slot-scope="scope">{{
            scope.row.question | striphtml
          }}</template>
        </el-table-column>
        <el-table-column
          prop="answer"
          label="คำตอบ"
          width="180"
          header-align="center"
          align="center"
          sortable
        >
          <template slot-scope="scope">
            <a class="message-over clamp1 height-20">{{
              getAnswer(scope.row.answer)
            }}</a>
          </template>
        </el-table-column>
        <el-table-column
          prop="durationTime"
          :label="
            `เปิด-ปิดแบบทดสอบ${
              testType == 'preTest' ? 'ก่อนเรียน' : 'หลังเรียน'
            }`
          "
          header-align="center"
          align="center"
          width="350"
        >
          <template>
            <span v-if="durationTime && durationTime.open">
              {{ durationTime.open | dateTimeThShort }} -
              {{ new Date(durationTime.close).setHours(23,59,59) | dateTimeThShort }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="updatedAt"
          label="วันที่และเวลาที่อัปเดต"
          :width="
            widthMax < 767.98
              ? '160'
              : widthMax < 1199
              ? '160'
              : widthMax > 1200
              ? '250'
              : ''
          "
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">{{
            scope.row.updatedAt | dateTimeTh
          }}</template>
        </el-table-column>
        <el-table-column label width="100" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex-display ai-center js-center">
              <div class="box-action">
                <div
                  @click="openCourse(scope.row._id)"
                  class="circle-action color-bg-secondary"
                >
                  <i class="fas fa-pen"></i>
                </div>
              </div>
              <div class="box-action">
                <el-popconfirm
                  confirmButtonText="ใช่"
                  cancelButtonText="ไม่"
                  icon="el-icon-info"
                  iconColor="red"
                  title="ท่านต้องการลบรายการนี้ใช่หรือไม่"
                  @onConfirm="delCourseTest(scope.row._id)"
                >
                  <div
                    slot="reference"
                    class="circle-action color-bg-danger-lighter"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </div>
                </el-popconfirm>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title
      :visible.sync="dialogCourseTestVisible"
      width="90%"
      top="1vh"
    >
      <div v-loading="loading">
        <div class="text-left pd-b-3 border-b">
          <h2 class="mg-less text-font-24 color-black">
            {{ courseTestEdit == false ? "เพิ่ม" : "แก้ไข"
            }}{{
              testType == "preTest"
                ? "แบบทดสอบก่อนเรียน (Pre Test)"
                : "แบบทดสอบหลังเรียน (Post Test)"
            }}
          </h2>
        </div>

        <div class="text-left">
          <p class="text-font-16">
            <span class="color-black">ชื่อหลักสูตร: </span>
            <span class="color-gray">{{ course.name }}</span>
            <span class="color-black pd-l-4">วิชา: </span>
            <span class="color-gray">{{ subject.name }}</span>
          </p>
        </div>
        <div v-if="dialogCourseTestVisible" class="modal-page">
          <CourseTestForm
            :type="courseTestEdit == false ? 'add' : 'update'"
            :testType="testType"
            :courseTest="courseTest"
            :startDate="subject.durationTime.open"
            :endDate="subject.durationTime.close"
            :durationTimeTest="durationTime"
            @createCourseTest="createCourseTest"
            @updateCourseTest="updateCourseTest"
          />
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title
      :visible.sync="dialogCourseTestCopy"
      class="modalCopy"
      width="80%"
    >
      <div  >
        <div class="text-left pd-b-4 border-b">
          <h2 class="mg-less text-font-24 color-black">
            นำเข้า {{
              testType == "preTest"
                ? "Post-Test"
                : "Pre-Test"
            }}
          </h2>
        </div>
        <div class="pd-y-4 check-all-box">
          <el-checkbox v-model="checkedAll" @change="checkAll" label="เลือกทั้งหมด" ></el-checkbox>
        </div>
        <div>
          <el-table
            :data="coureTestListCopy"
            border
            :header-row-style="tableHeaderStyle"
            :header-cell-style="tableHeaderStyle"
            empty-text="ไม่พบข้อมูล"
            v-loading="loading"
          >
            <el-table-column
              label="คัดลอกข้อสอบ"
              header-align="center"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                <div class="flex-display ai-center js-center">
                  <el-checkbox :value="getChecked(scope.row._id)"  @change="checkList(scope.row._id)"></el-checkbox>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              type="index"
              label="ลำดับ"
              header-align="center"
              align="center"
              width="80"
            ></el-table-column>
            <el-table-column
              prop="question"
              label="คำถาม"
              header-align="center"
              sortable
              :width="widthMax < 767.98 ? '' : ''"
            >
              <template slot-scope="scope">{{
                scope.row.question | striphtml
              }}</template>
            </el-table-column>
            <el-table-column
              prop="answer"
              label="คำตอบ"
              :width="widthMax < 1025 ? '' : '300'"
              header-align="center"
              align="center"
              sortable
            >
              <template slot-scope="scope">
                <a class="message-over clamp1 height-20">{{
                  getAnswer(scope.row.answer)
                }}</a>
              </template>
            </el-table-column>
          </el-table>
        </div>
        
        <div class="pd-t-3">
            <el-button

              @click="copyCourseTest"
              type="primary"
              round
              class="pd-x-1"
            >เพิ่มข้อสอบ</el-button
            >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { tableHeaderStyle } from "@/service/table";
import CourseTestForm from "@/components/courseTest/CourseTestForm";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    CourseTestForm,
  },
  props: {
    testType: {
      type: String,
      default() {
        return "preTest";
      },
    },
    coureTestList: {
      type: Array,
      default() {
        return [];
      },
    },
    coureTestListCopy: {
      type: Array,
      default() {
        return [];
      },
    },
    durationTime: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    courseList() {
      return this.$store.state.courseList;
    },
  },
  data() {
    return {
      widthMax: window.innerWidth,
      showTable: true,
      dialogCourseTestVisible: false,
      courseTestEdit: false,
      loading: false,
      courseTest: null,
      courseTestId: "",
      course: "",
      subject: "",
      dialogCourseTestCopy:false,
      checkedCourseTestCopy:[],
      checkedAll:false
    };
  },
  mounted() {
    this.setCourse();
    window.addEventListener("resize", this.resize);
  },
  methods: {
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);
    },
    resize() {
      this.showTable = false;
      this.widthMax = window.innerWidth;
      setTimeout(() => {
        this.showTable = true;
      }, 200);
    },
    setCourse() {
      let filter = this.courseList.filter(
        (filter) => filter._id == this.$route.query.courseId
      );

      if (filter.length > 0) {
        this.course = filter[0];
        let course = filter[0].subject.filter(
          (filter) => filter._id == this.$route.query.subjectId
        );

        if (course.length > 0) {
          this.subject = course[0];
        }
      }
    },
    delCourseTest(id) {
      this.loading = true;
      let obj = {
        _id: id,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`delete/test`, obj)
        .then((res) => {
          if (res.data.success) {
            this.$emit("fetchSubjectId");
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("createCourseTest error", e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    createCourseTest(data) {
      this.loading = true;
      let obj = {
        subjectId: this.$route.query.subjectId,
        question: data.courseTestQuestion,
        type: this.testType == "preTest" ? 1 : 2,
        answers: [
          {
            text: data.answer1,
            correct: data.correct == 1,
          },
          {
            text: data.answer2,
            correct: data.correct == 2,
          },
          {
            text: data.answer3,
            correct: data.correct == 3,
          },
          {
            text: data.answer4,
            correct: data.correct == 4,
          },
        ],
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`test`, obj)
        .then((res) => {
          if (res.data.success) {
            this.updateDurationTime(
              data.courseTestDistanceDate[0],
              data.courseTestDistanceDate[1]
            );
            this.fetchCourseList();
            this.dialogCourseTestVisible = false;
            this.$emit("fetchSubjectId");
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("createCourseTest error", e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    copyCourseTest(data) {
      if (this.checkedCourseTestCopy.length > 0) {
        this.loading = true;
        let obj = {
          type: this.testType == "preTest" ? 1 : 2,
          courseTest:this.checkedCourseTestCopy
        };

        HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
        HTTP.post(`copy/test`, obj)
          .then((res) => {
            if (res.data.success) {
              this.fetchCourseList();
              this.dialogCourseTestCopy = false;
              this.$emit("fetchSubjectId");
            } else {
              this.alertFailError();
            }
          })
          .catch((e) => {
            this.alertCatchError(e);
            console.log("createCourseTest error", e);
          })
          .finally(() => {
            setTimeout(() => {
              this.loading = false;
            }, 500);
            
          });
      }else{
        this.$message.error('กรุณาเลือกแบบทดสอบ');
      }
      
    },
    resetCourseTest() {
      this.courseTestId = "";
      this.courseTestEdit = false;
      this.courseTest = null;
    },
    openCourse(id) {
      this.setCourse();
      this.loading = true;
      this.courseTestId = id;
      this.dialogCourseTestVisible = true;
      this.courseTestEdit = true;

      let obj = {
        _id: id,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/test`, obj)
        .then((res) => {
          if (res.data.success) {
            this.courseTest = res.data.obj;
          }
        })
        .catch((e) => {
          console.log("openCourse error", e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateCourseTest(data) {
      this.loading = true;
      let obj = {
        _id: this.courseTestId,
        question: data.courseTestQuestion,
        type: this.testType == "preTest" ? 1 : 2,
        answers: [
          {
            _id: this.courseTest.answers[0]._id,
            text: data.answer1,
            correct: data.correct == 1,
          },
          {
            _id: this.courseTest.answers[1]._id,
            text: data.answer2,
            correct: data.correct == 2,
          },
          {
            _id: this.courseTest.answers[2]._id,
            text: data.answer3,
            correct: data.correct == 3,
          },
          {
            _id: this.courseTest.answers[3]._id,
            text: data.answer4,
            correct: data.correct == 4,
          },
        ],
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.put(`test`, obj)
        .then((res) => {
          if (res.data.success) {
            this.updateDurationTime(
              data.courseTestDistanceDate[0],
              data.courseTestDistanceDate[1]
            );
            this.fetchCourseList();
            this.dialogCourseTestVisible = false;
            this.$emit("fetchSubjectId");
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("updateCourseTest error", e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateDurationTime(open, close) {
      let obj = {
        subjectId: this.subject._id,
        durationTime: {
          open: open,
          close: close,
        },
        type: this.testType == "preTest" ? 1 : 2,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.put(`test/durationtime`, obj)
        .then((res) => {})
        .catch((e) => {
          console.log("updateDurationTime error", e);
        });
    },
    getAnswer(answer) {
      let filter = answer.filter((filter) => filter.correct == true);
      if (filter.length > 0) {
        return filter[0].text;
      } else {
        return "";
      }
    },
    checkAll(){
      if (this.checkedAll) {
        this.coureTestListCopy.map((item)=>{
          this.checkedCourseTestCopy.push(item._id)
        })
      }else{
        this.checkedCourseTestCopy = []
      }
     
    },
    checkList(id){
      let index = this.checkedCourseTestCopy.findIndex((index)=>index == id)
      if (index > -1) {
        this.checkedCourseTestCopy.splice(index,1)
      }else{
        this.checkedCourseTestCopy.push(id)
      }
      
      if (this.checkedCourseTestCopy.length != this.coureTestListCopy.length) {
        this.checkedAll = false
      }
      
    },
    getChecked(id){
      
      let filter = this.checkedCourseTestCopy.filter((filter)=>filter == id)
      return filter.length > 0?true:false
    }
  },
};
</script>

<style scoped>
  .check-all-box{
    display: flex;
    justify-content: flex-end;
  }
</style>